"use client";

import { useUserStore } from "@/core/stores";
import { handleSignIn } from "@/features/auth-functions";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "sonner";
import { useReadMyForms } from "./use-read-my-forms";

export function useSignIn() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const router = useRouter();
  const { setUser } = useUserStore();
  const { readForms } = useReadMyForms();

  const signIn = async () => {
    setLoading(true);
    try {
      const { user, error } = await handleSignIn(email, password);
      if (error || !user) return alert(error);
      setUser(user);
      router.push("/dashboard");
      readForms();
      toast("로그인되었어요!");
    } catch (e) {
      const error = e as Error;
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    setEmail,
    setPassword,
    signIn,
    disabled: !email || !password,
  };
}
